import { useSelector } from 'react-redux';

import selectOnlineOrderingLocationId from 'bento-ordering/base/selectors/selectOnlineOrderingLocationId';

function useLocationInformationByLocationId() {
  const onlineOrderingLocation = useSelector(selectOnlineOrderingLocationId);
  const restaurantLocations = useSelector(state => state.restaurantLocations);

  return restaurantLocations?.byId?.[onlineOrderingLocation] ?? {};
}

export default useLocationInformationByLocationId;
